import Ajax from './Ajax.js'

const Checkpoint = {
  getCheckpoints: (id = null) => {
    let uri = id !== null
      ? '/checkpoints' + '/' + id
      : '/checkpoints'
    return Ajax.get(uri)
  },
  getAreaCheckpoints: (id) => {
    return Ajax.get(`/checkpoints?area=${id}`)
  },
  postCheckpoints: (params) => {
    const payload = params && params.data ? params : { data: params }
    return Ajax.post('/checkpoints', payload)
  },
  putCheckpoints: (params) => {
    const id = params.id
    const data = { ...params }
    delete data.id
    const payload = params && params.data ? params : { data }
    return Ajax.put('/checkpoints/' + id, payload)
  },
  delCheckpoints: (id) => {
    return Ajax.delete('/checkpoints/' + id)
  },
  postCheckpointTreeTypes: (params) => {
    return Ajax.post('/checkpoint-tree-types/bulk', params)
  },
  postCheckpointTreeTypesFertilizing: (params) => {
    return Ajax.post('/checkpoint-tree-types/'+params.checkpoint_tree_type_id+'/fertilizing', params)
  },
  postTheoreticalStats: (params) => {
    return Ajax.post('/theoretical-stats/bulk', params)
  },

}

export default Checkpoint
